/**
 * The translations that are currently supported by the Bible Reader.
 * New translations need to be manually added since the Bible Reader cannot handle invalid translations.
 */

import {
  DEFAULT_BIBLE_TRANSLATION,
  SUPPORTED_BIBLE_TRANSLATIONS,
} from "~/constants";

/**
 * Sanitizes the reference to be in the format that the
 * Bible Reader expects.
 */
export function sanitizeReference(reference: string) {
  return reference.replace(/^Psalm /i, "Psalms ");
}

/**
 * Sanitizes the translation to be in the format that the
 * Bible Reader expects.
 */
export function sanitizeTranslation(translation: string) {
  return (
    SUPPORTED_BIBLE_TRANSLATIONS.find((t) => t === translation.toUpperCase()) ??
    DEFAULT_BIBLE_TRANSLATION
  );
}

/**
 * Constructs a Bible Reader link for the given reference.
 */
export function getBibleReaderLink(reference: string, translation = "nasb") {
  const referenceRegex =
    /^((?<leadingNumber>1|2|3) )?(?<book>[a-z]+) (?<chapter>[0-9]+).*/;

  const sanitizedReference = sanitizeReference(reference).toLowerCase();

  const match = sanitizedReference.match(referenceRegex);

  if (!match) {
    throw new Error("Invalid scripture reference");
  }

  const sanitizedTranslation = sanitizeTranslation(translation).toLowerCase();

  const { leadingNumber, book, chapter } = match.groups ?? {};

  return `https://bibleproject.com/bible/${sanitizedTranslation}/${leadingNumber ? leadingNumber + "-" : ""}${book}/${chapter}/`;
}
